import { render, staticRenderFns } from "./LengthDisplay.vue?vue&type=template&id=3fc855a3&scoped=true&"
import script from "./LengthDisplay.vue?vue&type=script&lang=js&"
export * from "./LengthDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc855a3",
  null
  
)

export default component.exports